import { useQuery } from "@tanstack/react-query";
import type { IProduct } from "../../../legacy/pages/ProductsListPage/entities/product/product.entity.interface";
import { SearchHistoryRepository } from "../../../legacy/services/search-bar/repositories/search-history/search-history.repository";
import { searchHistoryQueryKeys } from "./search-history.query-keys";
import type { IUseRecentProductsQuery } from "./useRecentProducts.query.interface";

const RECENT_PRODUCTS_LIMIT = 3;
const NO_RECENT_PRODUCTS: IProduct[] = [];

const searchHistoryRepository = new SearchHistoryRepository();

export function useRecentProductsQuery(enabled: boolean = true): IUseRecentProductsQuery {
  const query = useQuery({
    queryKey: searchHistoryQueryKeys.recents(),
    queryFn: function fetchRecentProducts() {
      return searchHistoryRepository.getProductsFromHistory(RECENT_PRODUCTS_LIMIT);
    },
    enabled,
    staleTime: 0,
    cacheTime: 0,
  });

  return {
    recentProducts: query.data ?? NO_RECENT_PRODUCTS,
    loading: query.isInitialLoading,
    error: (query.error as Error) ?? null,
  };
}
